import { render, staticRenderFns } from "./RoosterIcon.vue?vue&type=template&id=64eb296c"
import script from "./RoosterIcon.vue?vue&type=script&lang=js"
export * from "./RoosterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports